import React, {useState, useEffect, useRef} from 'react';
import {withTranslation} from 'react-i18next';
import {useNavigate, useParams} from "react-router-dom";
import {Panel} from "primereact/panel";
import {Tree} from 'primereact/tree';
import {InputText} from "primereact/inputtext";
import {InputNumber} from "primereact/inputnumber";
import {Dropdown} from "primereact/dropdown";
import {Button} from "primereact/button";
import {Sidebar} from "primereact/sidebar";
import {ConfirmDialog} from "primereact/confirmdialog";
import axios from "axios";
import Cookies from "js-cookie";

import _FM_CategoryFormComponent from "../components/_FM_category/_FM_CategoryFormComponent";
import _FM_UnitFormComponent from "../components/_FM_unit/_FM_UnitFormComponent";
import _FM_BerthFormComponent from "../components/_FM_berth/_FM_BerthFormComponent";
import _FM_UnitFormBulkComponent from "../components/_FM_unit/_FM_UnitFormBulkComponent";
import _FM_BerthFormBulkComponent from "../components/_FM_berth/_FM_BerthFormBulkComponent";
import _FM_AccommodationImportFormComponent from "../components/_FM_accommodation/_FM_AccommodationImportFormComponent";
import HelpComponent from "../components/HelpComponent";
import wizard from "../assets/images/gfx-wizard.png";

const _FM_BuilderPage = (props) => {

  const {t, i18n} = props;
  const navigate = useNavigate();
  const {accommodationId} = useParams();
  const [loading, setLoading] = useState(false);
  const [accommodations, setAccommodations] = useState([])
  const [nodes, setNodes] = useState([])
  const [selectedKeys, setSelectedKeys] = useState(null);
  const [selectedIds, setSelectedIds] = useState([]);
  const [categories, setCategories] = useState([]);
  const [units, setUnits] = useState([]);
  const [beds, setBeds] = useState([]);
  const [tmp, setTmp] = useState('');

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
  }

  useEffect(() => {
    document.title = t('builder') + ' - ' + process.env.REACT_APP_TITLE;
    window.App.help('/builder')
    apiCall('get', 'accommodation')
      .then(response => {
        setAccommodations(response.data.data.items);
        if (response.data.data.items && response.data.data.items[0]) {
          if(localStorage.getItem('selectedAccommodation')) {
            navigate('/builder/' + localStorage.getItem('selectedAccommodation'))
          } else {
            navigate('/builder/' + response.data.data.items[0].id)
            if (!localStorage.getItem('selectedAccommodation')) {
              localStorage.setItem('selectedAccommodation', response.data.data.items[0].id)
            }
          }
        } else {
          window.App.toastShow('warn', t('warning'), t('no_accommodation_found'));
        }
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
  }, []);

  useEffect(() => {
    if (accommodationId) {
      apiCall('get', "residential-category?search[accommodation]=" + accommodationId)
        .then(response => {
          let _cats = []
          response.data.data.items.map((cat, index) => {
            _cats.push({
              key: 'C-' + cat.id,
              originalId: cat.id,
              originalData: cat,
              parentId: null,
              type: 'category',
              level: 1,
              label: cat.name,
              expanded: true,
              draggable: false,
              selectable: false,
            })
          })
          setCategories(_cats)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
      apiCall('get', 'residential-unit/tree')
        .then(response => {
          let _units = []
          response.data.map((unit, index) => {
            _units.push({
              key: 'U-' + unit.id,
              originalId: unit.id,
              originalData: unit,
              parentId: unit.residential_category.id,
              type: 'unit',
              level: 2,
              label: unit.name,
              expanded: true,
              draggable: true,
              selectable: false,
              children: unit.children
            })
          })
          setUnits(_units)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
      apiCall('get', 'berth')
        .then(response => {
          let _beds = []
          response.data.data.items.map((bed, index) => {
            _beds.push({
              key: 'B-' + bed.id,
              originalId: bed.id,
              originalData: bed,
              parentId: bed.residential_unit.id,
              type: 'bed',
              level: 3,
              label: bed.name,
              draggable: true,
            })
          })
          setBeds(_beds)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
    }
  }, [
    accommodationId,
    window.App.state.rerenderCategoryList,
    window.App.state.rerenderUnitList,
    window.App.state.rerenderBerthList,
  ]);

  useEffect(() => {
    let _nodes = []
    categories.map((category, index) => {
      let _units = units.filter(item => item.parentId === category.originalId)
      let __units = []
      _units.map((unit, index) => {
        let _beds = beds.filter(item => item.parentId === unit.originalId)
        let _children = []
        if (unit.children && unit.children[0]) {
          unit.children.map((children, index) => {
            let __beds = []
            if (children.berths && children.berths[0]) {
              children.berths.map((bed, index) => {
                __beds.push({
                  key: 'BB-' + bed.id,
                  originalId: bed.id,
                  originalData: bed,
                  parentId: children.originalId,
                  type: 'bed',
                  level: 4,
                  label: bed.name,
                  draggable: true,
                })
              })
            }
            _children.push({
              key: 'UU-' + children.id,
              originalId: children.id,
              originalData: children,
              parentId: unit.originalId,
              type: 'unit',
              level: 3,
              label: children.name,
              expanded: true,
              draggable: true,
              selectable: false,
              children: __beds
            })
          })
          _beds = [
            ..._beds,
            ..._children
          ]
        }
        __units.push({
          ...unit,
          children: _beds
        })
      })
      _nodes.push({
        ...category,
        children: __units
      })
    })
    setNodes(_nodes)
  }, [categories, units, beds]);

  return (
    <div className="_FM_BuilderPage p-component p-m-lg-4">
      <HelpComponent type={"site"} position={"TOP_OF_THE_PAGE"} url={"/builder"}/>
      {accommodations && accommodations[0] &&

        <Panel>
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-6 p-col-align-center"}>
              {accommodationId &&
                <Button type="button" label={t('new_category')} icon={"pi pi-plus"}
                        onClick={() => {
                          navigate('/builder/' + accommodationId + '?create=category')
                        }}
                        className="p-button-success p-mr-2"/>
              }
              {selectedIds && selectedIds[0] &&
                <>
                  <Button type="button" label={t('delete_selected')} icon={"pi pi-trash"}
                          onClick={() => {
                            window.App.setState({confirmDeleteBuilderBerthBulk: true})
                          }}
                          className="p-button-danger p-mr-2"/>
                  <ConfirmDialog group="declarative" visible={window.App.state.confirmDeleteBuilderBerthBulk}
                                 acceptLabel={t('yes')} rejectLabel={t('no')}
                                 onHide={() => {
                                   window.App.setState({confirmDeleteBuilderBerthBulk: false})
                                 }}
                                 message={t('confirm_delete')} header={t('confirm_delete')}
                                 icon="pi pi-exclamation-triangle"
                                 accept={() => {
                                   apiCall('delete', 'berth/bulk-delete', selectedIds)
                                     .then(response => {
                                       window.App.toastShow('success', 'Sikeres törlés!',);
                                       window.App.setState({
                                         rerenderBerthList:  Math.random(),
                                       })
                                     })
                                     .catch(error => {
                                       window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                                     })
                                 }}
                                 reject={() => {
                                   window.App.setState({confirmDeleteBuilderBerthBulk: false})
                                 }}/>
                </>
              }
            </div>
            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-right"}>
              <HelpComponent type={"site"} position={"UNDER_HELP_BUTTON"}/>
              {Cookies.get('roles') && Cookies.get('roles').toString().includes('ROLE_SUPER_ADMIN') &&
                <Button type="button"
                        label={t('accommodation_import')}
                        icon={"pi pi-upload"}
                        onClick={() => {
                          navigate('/builder/' + accommodationId + '?import=accommodation')
                        }}
                        className="p-button-secondary p-ml-2"/>
              }
              {nodes && !nodes[0] &&
                <>Válassz száláshelyet: &nbsp;</>
              }
              <Dropdown  options={accommodations}
                        optionLabel="name"
                        optionValue="id"
                        emptyMessage={t('empty_message')}
                        className={"p-ml-2 p-text-left"}
                        onChange={(e) => {
                          navigate('/builder/' + e.value)
                          localStorage.setItem('selectedAccommodation', e.value)
                        }}
                        value={Number(localStorage.getItem('selectedAccommodation'))}
              />
            </div>
          </div>
          {nodes && nodes[0] ? (
            <>
              <Tree value={nodes}
                    header={() => {
                      return (
                        <>
                          <div className={"category"}>
                            <div className={"p-grid"}>
                              <div className={"p-col-2"}>

                              </div>
                              <div className={"p-col-2 p-text-center"}>
                                {t('name')}
                              </div>
                              <div className={"p-col-2 p-text-center"}>
                                {t('number_of_single_beds')}
                              </div>
                              <div className={"p-col-2 p-text-center"}>
                                {t('number_of_double_beds')}
                              </div>
                              <div className={"p-col-2 p-text-center"}>

                              </div>
                              <div className={"p-col-2"}>

                              </div>
                            </div>
                          </div>
                          <div className={"unit"}>
                            <div className={"p-grid"}>
                              <div className={"p-col-2"}>

                              </div>
                              <div className={"p-col-2 p-text-center"}>
                                {t('name')}
                              </div>
                              <div className={"p-col-2 p-text-center"}>
                                {t('number_of_single_beds')}
                              </div>
                              <div className={"p-col-2 p-text-center"}>
                                {t('number_of_double_beds')}
                              </div>
                              <div className={"p-col-2 p-text-center"}>
                                {t('number_of_extra_beds')}
                              </div>
                              <div className={"p-col-2"}>

                              </div>
                            </div>
                          </div>
                        </>
                      )
                    }}
                    // metaKeySelection={true}
                    selectionMode="single"
                    selectionKeys={selectedKeys}
                    onSelectionChange={(e, node) => {
                      let _selectedIds = []
                      let values = Object.keys(e.value)
                      if (values && values[0]) {
                        values.map((value, index) => {
                          var selectedId = beds.filter(item => item.key === value)
                          _selectedIds.push(selectedId[0]?.originalId)
                        })
                      }
                      setSelectedIds(_selectedIds)
                      setSelectedKeys(e.value)
                    }}
                    dragdropScope="0"
                    onDragDrop={(e) => {
                      if (e.dragNode.type && e.dragNode.type === 'unit') {
                        if (e.dropNode.type && e.dropNode.type === 'category') {
                          apiCall('patch', 'residential-unit/' + e.dragNode.originalId, {
                            residential_category: e.dropNode.originalId,
                            parent: null
                          })
                            .then(response => {
                              window.App.toastShow('success', t('success'), response.data.message)
                              window.App.setState({
                                rerenderUnitList:  Math.random(),
                              })
                            })
                            .catch(error => {
                              window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
                            })
                        } else if (e.dropNode.type && e.dropNode.type === 'unit' && e.dropNode.level < 3) {
                          apiCall('patch', 'residential-unit/' + e.dragNode.originalId, {
                            parent: e.dropNode.originalId,
                            residential_category: e.dropNode?.originalData?.residential_category?.id,
                          })
                            .then(response => {
                              window.App.toastShow('success', t('success'), response.data.message)
                              window.App.setState({
                                rerenderUnitList:  Math.random(),
                              })
                            })
                            .catch(error => {
                              window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
                            })
                        }
                      } else if (e.dragNode.type && e.dragNode.type === 'bed') {
                        apiCall('patch', 'berth/' + e.dragNode.originalId, {
                          residential_unit: e.dropNode.originalId
                        })
                          .then(response => {
                            window.App.toastShow('success', t('success'), response.data.message)
                            window.App.setState({
                              rerenderBerthList:  Math.random(),
                            })
                          })
                          .catch(error => {
                            window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
                          })
                      }
                    }}
                    togglerTemplate={() => {
                      return (
                        false
                      )
                    }}
                    nodeTemplate={(node, options) => {
                      if (node.type === 'category') {
                        return (
                          <div className={node.type}>
                            <div className={"p-grid"}>
                              <div className={"p-col-2 p-col-align-center"}>
                                {t('residential_category')}
                              </div>
                              <div className={"p-col-2 p-col-align-center"}>
                                <InputText id={node.originalId + "name"}
                                           disabled={loading}
                                           onClick={(e) => setTmp(e.target.value)}
                                           onBlur={(e) => {
                                             if (e.target.value && e.target.value !== tmp) {
                                               setLoading(true)
                                               apiCall('patch', 'residential-category/' + node.originalId, {
                                                 name: e.target.value
                                               })
                                                 .then(response => {
                                                   window.App.toastShow('success', t('success'), response.data.message)
                                                   window.App.setState({
                                                     rerenderUnitList:  Math.random(),
                                                   })
                                                   setLoading(false)
                                                 })
                                                 .catch(error => {
                                                   setLoading(false)
                                                   window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
                                                 })
                                             }
                                           }}
                                           onChange={(e) => {
                                             node.label = e.target.value
                                             window.App.forceUpdate()
                                           }}
                                           value={node.label}
                                           className={"w-100"}/>
                              </div>
                              <div className={"p-col-2 p-col-align-center"}>
                                <InputText id={node.originalId + "-number_of_single_beds"}
                                             disabled={loading}
                                             keyfilter={"num"}
                                             onClick={(e) => setTmp(e.target.value)}
                                             onBlur={(e) => {
                                               if (e.target.value && e.target.value !== tmp) {
                                                 setLoading(true)
                                                 apiCall('patch', 'residential-category/' + node.originalId, {
                                                   number_of_single_beds: e.target.value
                                                 })
                                                   .then(response => {
                                                     window.App.toastShow('success', t('success'), response.data.message)
                                                     window.App.setState({
                                                       rerenderUnitList:  Math.random(),
                                                     })
                                                     setLoading(false)
                                                   })
                                                   .catch(error => {
                                                     setLoading(false)
                                                     window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
                                                   })
                                               }
                                             }}
                                             value={node.originalData.number_of_single_beds}
                                             onChange={(e) => {
                                               node.originalData.number_of_single_beds = e.target.value
                                               window.App.forceUpdate()
                                             }}
                                             className={"w-100"}/>
                              </div>
                              <div className={"p-col-2 p-col-align-center"}>
                                <InputText id={node.originalId + "-number_of_double_beds"}
                                             keyfilter={"num"}
                                             disabled={loading}
                                             onClick={(e) => setTmp(e.target.value)}
                                             onBlur={(e) => {
                                               if (e.target.value && e.target.value !== tmp) {
                                                 setLoading(true)
                                                 apiCall('patch', 'residential-category/' + node.originalId, {
                                                   number_of_double_beds: e.target.value
                                                 })
                                                   .then(response => {
                                                     window.App.toastShow('success', t('success'), response.data.message)
                                                     window.App.setState({
                                                       rerenderUnitList:  Math.random(),
                                                     })
                                                     setLoading(false)
                                                   })
                                                   .catch(error => {
                                                     setLoading()
                                                     window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
                                                   })
                                               }
                                             }}
                                             value={node.originalData.number_of_double_beds}
                                             onChange={(e) => {
                                               node.originalData.number_of_double_beds = e.target.value
                                               window.App.forceUpdate()
                                             }}
                                             className={"w-100"}/>
                              </div>
                              <div className={"p-col-2 p-col-align-center"}>

                              </div>
                              <div className={"p-col-2 p-col-align-center p-text-right"}>
                                <Button type="button" icon="pi pi-bolt" tooltip={t('bulk_actions')}
                                        onClick={(e) => {
                                          navigate('/builder/' + accommodationId + '?createBulk=unit')
                                          window.App.setState({
                                            selectedCategory: node.originalId,
                                            selectedUnit: null
                                          })
                                        }}
                                        small
                                        className="p-button-success p-ml-2"/>
                                <Button type="button" icon={"pi pi-plus"}
                                        onClick={() => {
                                          navigate('/builder/' + accommodationId + '?create=unit')
                                          window.App.setState({
                                            selectedCategory: node.originalId,
                                            selectedUnit: null
                                          })
                                        }}
                                        tooltip={t('new_unit')}
                                        small
                                        className="p-button-success p-ml-2"/>
                                <Button icon="pi pi-trash" className="p-button-danger p-ml-2"
                                        tooltip={t('delete')}
                                        tooltipOptions={{position: 'left'}}
                                        small
                                        onClick={() => {
                                          window.App.setState({[`confirmDeleteBuilderCategory${node.originalId}`]: true})
                                        }}
                                />
                                <ConfirmDialog group="declarative"
                                               visible={window.App.state[`confirmDeleteBuilderCategory${node.originalId}`]}
                                               acceptLabel={t('yes')} rejectLabel={t('no')}
                                               onHide={() => {
                                                 window.App.setState({[`confirmDeleteBuilderCategory${node.originalId}`]: false})
                                               }}
                                               message={t('confirm_delete')} header={t('confirm_delete')}
                                               icon="pi pi-exclamation-triangle"
                                               accept={() => {
                                                 apiCall('delete', 'residential-category/' + node.originalId)
                                                   .then(response => {
                                                     window.App.setState({rerenderCategoryList:  Math.random()})
                                                     window.App.toastShow('success', 'Sikeres törlés!',);
                                                   })
                                                   .catch(error => {
                                                     window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                                                   })
                                               }}
                                               reject={() => {
                                                 window.App.setState({[`confirmDeleteBuilderCategory${node.originalId}`]: false})
                                               }}/>
                              </div>
                            </div>
                          </div>
                        )
                      }
                      if (node.type === 'unit') {
                        return (
                          <div className={node.type + " unit-level-" + node.level}>
                            <div className={"p-grid"}>
                              <div className={"p-col-2 p-col-align-center"}>
                                <i className={"pi pi-th-large p-mr-2"}></i>
                                {t('residential_unit')}
                              </div>
                              <div className={"p-col-2 p-col-align-center"}>
                                <InputText id={node.originalId + "-name"}
                                           onClick={(e) => setTmp(e.target.value)}
                                           disabled={loading}
                                           onBlur={(e) => {
                                             if (e.target.value && e.target.value !== tmp) {
                                               setLoading(true)
                                               apiCall('patch', 'residential-unit/' + node.originalId, {
                                                 name: e.target.value
                                               })
                                                 .then(response => {
                                                   window.App.toastShow('success', t('success'), response.data.message)
                                                   window.App.setState({
                                                     rerenderUnitList:  Math.random(),
                                                   })
                                                   setLoading(false)
                                                 })
                                                 .catch(error => {
                                                   window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
                                                   setLoading(false)
                                                 })
                                             }
                                           }}
                                           value={node.label}
                                           onChange={(e) => {
                                             node.label = e.target.value
                                             window.App.forceUpdate()
                                           }}
                                           className={"w-100"}/>
                              </div>
                              <div className={"p-col-2 p-col-align-center"}>
                                <InputText id={node.originalId + "-number_of_single_beds"}
                                             keyfilter={"num"}
                                             disabeld={loading}
                                             onClick={(e) => setTmp(e.target.value)}
                                             onBlur={(e) => {
                                               if (e.target.value && e.target.value !== tmp) {
                                                 setLoading(true)
                                                 apiCall('patch', 'residential-unit/' + node.originalId, {
                                                   number_of_single_beds: e.target.value
                                                 })
                                                   .then(response => {
                                                     window.App.toastShow('success', t('success'), response.data.message)
                                                     window.App.setState({
                                                       rerenderUnitList:  Math.random(),
                                                     })
                                                     setLoading(false)
                                                   })
                                                   .catch(error => {
                                                     window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
                                                     setLoading(false)
                                                   })
                                               }
                                             }}
                                             value={node.originalData.number_of_single_beds}
                                             onChange={(e) => {
                                               node.originalData.number_of_single_beds = e.target.value
                                               window.App.forceUpdate()
                                             }}
                                             className={"w-100"}/>
                              </div>
                              <div className={"p-col-2 p-col-align-center"}>
                                <InputText id={node.originalId + "-number_of_double_beds"}
                                             keyfilter={"num"}
                                             disabled={loading}
                                             onClick={(e) => setTmp(e.target.value)}
                                             onBlur={(e) => {
                                               if (e.target.value && e.target.value !== tmp) {
                                                 setLoading(true)
                                                 apiCall('patch', 'residential-unit/' + node.originalId, {
                                                   number_of_double_beds: e.target.value
                                                 })
                                                   .then(response => {
                                                     setLoading(false)
                                                     window.App.toastShow('success', t('success'), response.data.message)
                                                     window.App.setState({
                                                       rerenderUnitList:  Math.random(),
                                                     })
                                                   })
                                                   .catch(error => {
                                                     window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
                                                     setLoading(false)
                                                   })
                                               }
                                             }}
                                             value={node.originalData.number_of_double_beds}
                                             onChange={(e) => {
                                               node.originalData.number_of_double_beds = e.target.value
                                               window.App.forceUpdate()
                                             }}
                                             className={"w-100"}/>
                              </div>
                              <div className={"p-col-2 p-col-align-center"}>
                                <InputText id={node.originalId + "-number_of_extra_beds"}
                                             disabled={loading}
                                             keyfilter={"num"}
                                             onClick={(e) => setTmp(e.target.value)}
                                             onBlur={(e) => {
                                               if (e.target.value && e.target.value !== tmp) {
                                                 setLoading(true)
                                                 apiCall('patch', 'residential-unit/' + node.originalId, {
                                                   number_of_extra_beds: e.target.value
                                                 })
                                                   .then(response => {
                                                     window.App.toastShow('success', t('success'), response.data.message)
                                                     window.App.setState({
                                                       rerenderUnitList:  Math.random(),
                                                     })
                                                     setLoading(false)
                                                   })
                                                   .catch(error => {
                                                     window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
                                                     setLoading(false)
                                                   })
                                               }
                                             }}
                                             value={node.originalData.number_of_extra_beds}
                                             onChange={(e) => {
                                               node.originalData.number_of_extra_beds = e.target.value
                                               window.App.forceUpdate()
                                             }}
                                             className={"w-100"}/>
                              </div>
                              <div className={"p-col-2 p-col-align-center p-text-right"}>
                                <Button type="button" icon="pi pi-bolt" tooltip={t('bulk_actions')}
                                        onClick={(e) => {
                                          navigate('/builder/' + accommodationId + '?createBulk=berth')
                                          window.App.setState({
                                            selectedUnit: node.originalId,
                                          })
                                        }} small
                                        className="p-button-success p-ml-2"/>
                                <Button type="button" icon={"pi pi-plus"}
                                        tooltip={t('new_berth')}
                                        onClick={() => {
                                          navigate('/builder/' + accommodationId + '?create=berth')
                                          window.App.setState({
                                            selectedUnit: node.originalId,
                                          })
                                        }}
                                        small
                                        className="p-button-success p-ml-2"/>

                                <Button type="button" icon={"pi pi-list"}
                                        tooltip={t('new_unit')}
                                        disabled={node.level === 3}
                                        onClick={() => {
                                          navigate('/builder/' + accommodationId + '?create=unit')
                                          window.App.setState({
                                            selectedCategory: node.originalData.residential_category.id,
                                            selectedUnit: node.originalId,
                                          })
                                        }}
                                        small
                                        className="p-button-success p-ml-2"/>
                                <Button icon="pi pi-trash" className="p-button-danger p-ml-2"
                                        tooltip={t('delete')}
                                        tooltipOptions={{position: 'left'}}
                                        small
                                        onClick={() => {
                                          window.App.setState({[`confirmDeleteBuilderUnit${node.originalId}`]: true})
                                        }}
                                />
                                <ConfirmDialog group="declarative"
                                               visible={window.App.state[`confirmDeleteBuilderUnit${node.originalId}`]}
                                               acceptLabel={t('yes')} rejectLabel={t('no')}
                                               onHide={() => {
                                                 window.App.setState({[`confirmDeleteBuilderUnit${node.originalId}`]: false})
                                               }}
                                               message={t('confirm_delete')} header={t('confirm_delete')}
                                               icon="pi pi-exclamation-triangle"
                                               accept={() => {
                                                 apiCall('delete', 'residential-unit/' + node.originalId)
                                                   .then(response => {
                                                     window.App.setState({rerenderUnitList: Math.random()})
                                                     window.App.toastShow('success', 'Sikeres törlés!',);
                                                   })
                                                   .catch(error => {
                                                     window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                                                   })
                                               }}
                                               reject={() => {
                                                 window.App.setState({[`confirmDeleteBuilderUnit${node.originalId}`]: false})
                                               }}/>
                              </div>
                            </div>
                          </div>
                        )
                      }
                      if (node.type === 'bed') {
                        return (
                          <div className={node.type + " bed-level-" + node.level}>
                            <div className={"p-grid"}>
                              <div className={"p-col-2 p-col-align-center"}>
                                <i className={"pi pi-th-large p-mr-2"}></i>
                                {t('berth')}
                              </div>
                              <div className={"p-col-2 p-col-align-center"}>
                                <InputText id={node.originalId + "-name"}
                                           disabled={loading}
                                           onClick={(e) => setTmp(e.target.value)}
                                           onBlur={(e) => {
                                             if (e.target.value && e.target.value !== tmp) {
                                               setLoading(true)
                                               apiCall('patch', 'berth/' + node.originalId, {
                                                 name: e.target.value
                                               })
                                                 .then(response => {
                                                   window.App.toastShow('success', t('success'), response.data.message)
                                                   window.App.setState({
                                                     rerenderUnitList: Math.random(),
                                                   })
                                                   setLoading(false)
                                                 })
                                                 .catch(error => {
                                                   window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
                                                   setLoading(false)
                                                 })
                                             }
                                           }}
                                           value={node.label}
                                           onChange={(e) => {
                                             node.label = e.target.value
                                             window.App.forceUpdate()
                                           }}
                                           className={"w-100"}/>
                              </div>
                              <div className={"p-col-6"}>

                              </div>
                              <div className={"p-col-2 p-col-align-center p-text-right"}>
                                <Button icon="pi pi-trash" className="p-button-danger p-ml-2"
                                        tooltip={t('delete')}
                                        tooltipOptions={{position: 'left'}}
                                        small
                                        onClick={() => {
                                          window.App.setState({[`confirmDeleteBuilderBerth${node.originalId}`]: true})
                                        }}
                                />
                                <ConfirmDialog group="declarative"
                                               visible={window.App.state[`confirmDeleteBuilderBerth${node.originalId}`]}
                                               acceptLabel={t('yes')} rejectLabel={t('no')}
                                               onHide={() => {
                                                 window.App.setState({[`confirmDeleteBuilderBerth${node.originalId}`]: false})
                                               }}
                                               message={t('confirm_delete')} header={t('confirm_delete')}
                                               icon="pi pi-exclamation-triangle"
                                               accept={() => {
                                                 apiCall('delete', 'berth/' + node.originalId)
                                                   .then(response => {
                                                     window.App.setState({rerenderBerthList: Math.random()})
                                                     window.App.toastShow('success', 'Sikeres törlés!',);
                                                   })
                                                   .catch(error => {
                                                     window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                                                   })
                                               }}
                                               reject={() => {
                                                 window.App.setState({[`confirmDeleteBuilderBerth${node.originalId}`]: false})
                                               }}/>
                              </div>
                            </div>
                          </div>
                        )
                      }
                    }}
              />
              <div className={"p-text-center p-mt-3"}>
                <Button type="button"
                        icon="pi pi-cog"
                        label={t('price_settings')}
                        className="p-button-info"
                        loading={loading}
                        onClick={() => {
                          navigate('/price')
                        }}/>

              </div>
            </>
          ):(
            <div className={"p-text-center"}>
              {/*<img src={wizard} alt={"Felhomatrac Varázsló"} style={{width: '200px'}} />*/}
              {/*<h2 className={"p-my-0"}>{t('onboarding_builder_welcome')}</h2>*/}
              {/*<h3 >{t('onboarding_builder_welcome_text')}</h3>*/}
              {/*<p className={"onboarding_welcome_text p-my-0"}>{t('onboarding_builder_description')}</p>*/}
              {/*<div className={"p-my-3 p-align-center"}>*/}
              {/*  <Button type="button"*/}
              {/*          label={t('onboarding_builder_start')}*/}
              {/*          className="p-button-succes-alt"*/}
              {/*          loading={loading}*/}
              {/*          onClick={() => {*/}
              {/*            navigate('/builder/' + accommodationId + '?create=category')*/}
              {/*          }}/>*/}
              {/*</div>*/}
        </div>
          )}
        </Panel>
      }
      <Sidebar position="right" visible={window.App.urlVars().create === 'category'} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate('/builder/' + accommodationId)
               }}>
        <_FM_CategoryFormComponent/>
      </Sidebar>
      <Sidebar position="right" visible={window.App.urlVars().createBulk === 'unit'} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate('/builder/' + accommodationId)
               }}>
        <_FM_UnitFormBulkComponent/>
      </Sidebar>
      <Sidebar position="right" visible={window.App.urlVars().create === 'unit'} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate('/builder/' + accommodationId)
               }}>
        <_FM_UnitFormComponent/>
      </Sidebar>
      <Sidebar position="right" visible={window.App.urlVars().createBulk === 'berth'} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate('/builder/' + accommodationId)
               }}>
        <_FM_BerthFormBulkComponent/>
      </Sidebar>
      <Sidebar position="right" visible={window.App.urlVars().create === 'berth'} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate('/builder/' + accommodationId)
               }}>
        <_FM_BerthFormComponent/>
      </Sidebar>
      <Sidebar position="right" visible={window.App.urlVars().import === 'accommodation'} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate('/builder/' + accommodationId)
               }}>
        <_FM_AccommodationImportFormComponent/>
      </Sidebar>
    </div>
  )
}
export default withTranslation('common')(_FM_BuilderPage);
